import { render, staticRenderFns } from "./SupplierGalleryContentForm.vue?vue&type=template&id=3dc42d84&"
import script from "./SupplierGalleryContentForm.vue?vue&type=script&lang=js&"
export * from "./SupplierGalleryContentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports